
import Blinded from "./Blinded.jpg";
import Burning from "./Burning.jpg";
import Charmed from "./Charmed.jpg";
import Crouched from "./Crouched.jpg";
import Dazed from "./Dazed.jpg";
import Deafened from "./Deafened.jpg";
import Diseased from "./Diseased.jpg";
import Exhaustion from "./Exhaustion.jpg";
import Frightened from "./Frightened.jpg";
import Grappled from "./Grappled.jpg";
import Incapacitated from "./Incapacitated.jpg";
import Invisible from "./Invisible.jpg";
import Paralyzed from "./Paralyzed.jpg";
import Petrified from "./Petrified.jpg";
import Poisoned from "./Poisoned.jpg";
import Prone from "./Prone.jpg";
import Restrained from "./Restrained.jpg";
import Silenced from "./Silenced.jpg";
import Slow from "./Slow.jpg";
import Stopped from "./Stopped.jpg";
import Unconscious from "./Unconscious.jpg";

export const CONDITION_URLS = [
  Blinded,
  Burning,
  Charmed,
  Crouched,
  Dazed,
  Deafened,
  Diseased,
  Exhaustion,
  Frightened,
  Grappled,
  Incapacitated,
  Invisible,
  Paralyzed,
  Petrified,
  Poisoned,
  Prone,
  Restrained,
  Silenced,
  Slow,
  Stopped,
  Unconscious
];